import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { UserService } from './user.service';
import { Observable, observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApiService {

    // apiBaseRegister: String = "https://sdapi.songdew.com/apis/v2";
    // public apiBaseV2: String = "https://sdapi.songdew.com/apis/v2";
    // apiBase: String = 'https://sdapi.songdew.com/apis';


    apiBaseRegister: String = "https://orbit.songdew.com/apis/v2";
    public apiBaseV2: String = "https://orbit.songdew.com/apis";
    apiBase: String = 'https://orbit.songdew.com/apis';

    // apiBase: String = "http://164.52.200.19:8000/apis"
    // public apiBaseV2: String = "http://164.52.200.19:8000/apis/v2";
    // apiBaseRegister: String = "http://164.52.200.19:8000/apis/v2"


    urlRevenuePdf = "https://sdapi.songdew.com"; // Revenue Report Base Url
    angularBase = 'https://songdew.com';
    artistPageSongBaseUrl = "";
    cdn = "https://songdewnetwork.com";
    oppCountryBase = "https://sdapi.songdew.com/apis/v2";
    //oppCountryBase: String = "http://164.52.200.19:8000/apis/v2"




    oppApiBase = "https://sdapi.songdew.com/apis"
    apiArtistListing: String = "https://sdapi.songdew.com/apis";




    constructor(private http: HttpClient, private user: UserService) { }

    helpdeskUrl(userToken: string) {

        const callback = encodeURIComponent(
            'http://helpdesk.songdew.com/support/sso/login/?next=/support/'
        );

        const authToken = encodeURIComponent(
            userToken.replace(/^Token\s+/i, '')
        );
        console.log(`https://sdapi.songdew.com/sso/authorization/` +
            `?next=${callback}` +
            `&auth_token=${authToken}`)

        return (
            `https://sdapi.songdew.com/sso/authorization/` +
            `?next=${callback}` +
            `&auth_token=${authToken}`
        );
    }

    public subCheck(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return this.http.get(this.apiBase + '/check_pro/', {
            headers: headers,
        });
    }

    public sessionCheck(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/check_session/', {
            headers: headers,
        });
    }

    public login(email, password): any {
        return this.http.post(this.apiBase + '/obtain_auth_token/', {
            email: email,
            password: password,
            source: 'web',
        });
    }

    public sociaLogin(access_token, provider, from = ''): any {
        let params = new HttpParams();
        params = params.append('access_token', access_token);
        params = params.append('provider', provider.toLowerCase());
        let register_from = '';
        if (provider == 'FACEBOOK') {
            register_from = '2';
        } else if (provider == 'GOOGLE') {
            register_from = '5';
        }
        params = params.append('register_from', register_from);
        params = params.append('social_login_action', from);
        params = params.append('source', 'web');

        return this.http.get(this.apiBase + '/social_login/', {
            params: params,
        });
    }

    public logout(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/logout/', {
            headers: headers,
        });
    }
    public getOppCountries(): any {
        return this.http.get(this.oppCountryBase + "/country/");
    }
    public getCountries(): any {
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/country/', { params: params });
    }
    public getCities(state_id): any {
        let params = new HttpParams();
        params = params.append('state_id', state_id);

        return this.http.get(this.apiBase + '/cities/', { params: params });
    }

    public getBandRoles(): any {
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/band-roles/', { params: params });
    }
    public saveBandMembers(members): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/band-members/',
            {
                members: members,
                user_id: this.user.id,
                user_slug: this.user.slug,
            },
            {
                headers: headers,
            }
        );
    }
    public getBandMembers(other = false, slug = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', other ? slug : this.user.slug);

        return this.http.get(this.apiBase + '/band-members/', {
            params: params,
            headers: headers,
        });
    }

    public getGenres(available = false, type = "", lang = "", music_type = ""): any {
        let params = new HttpParams();
        params = params.append("type", type);
        params = params.append("lng", lang);
        if (music_type == 'video') {
            return this.http.get(this.apiBase + "/v2/v-genre-available/", {
                params: params,
            });
        } else {
            if (available) {
                return this.http.get(this.apiBase + "/genre-available/", {
                    params: params,
                });
            } else {
                return this.http.get(this.apiBase + "/genre/", { params: params });
            }
        }
    }






    public toggleVideo(slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.put(this.apiBase + "/toggle_video_privacy/",
            {
                video_slug: slug
            },
            {
                headers: headers
            }
        );
    }

    public submitWebsite(slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(this.apiBase + "/upload_on_website/",
            {
                video_slug: slug
            },
            {
                headers: headers
            }
        );
    }

    public pitchTv(slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(this.apiBase + "/apply_for_tv/",
            {
                video_slug: slug
            },
            {
                headers: headers
            }
        );
    }

    public dashboardOpportunity(limit: any): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        var localurl = "/dashboard/featured_opportunities/?offset=0&limit=" + limit + "&is_dashboard=true&category=2";
        return this.http.get(this.apiBase + localurl, {
            params: params,
            headers: headers,
        });
    }

    public dashboardAd(limit: any): any {
        let params = new HttpParams();
        var localurl = "/dashboard/adv_banner/?offset=0&limit=" + limit;
        return this.http.get(this.apiBase + localurl, { params: params });
    }
    public opportunityUse(): any {
        return this.http.get(this.apiBase + '/dashboard/weekly-new-opp-count-for-user');
    }


    public getArtistCat(): any {
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/artistcat/', { params: params });
    }

    public getMoods(): any {
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/mood/', { params: params });
    }

    public getGenreOnBoard(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/genre_onboard/', {
            params: params,
            headers: headers,
        });
    }
    public selectGenreOnBoard(genre_ids): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/genre_onboard/',
            {
                genre_ids: genre_ids,
            },
            {
                headers: headers,
            }
        );
    }

    public getLanguageOnBoard(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/language_onboard/', {
            params: params,
            headers: headers,
        });
    }
    public selectLanguageOnBoard(language_ids): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/language_onboard/',
            {
                language_ids: language_ids,
            },
            {
                headers: headers,
            }
        );
    }

    public getArtistsOnBoard(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/artists_on_board/', {
            params: params,
            headers: headers,
        });
    }
    public selectArtistsOnBoard(artist_ids): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/artists_on_board/',
            {
                artist_ids: artist_ids,
            },
            {
                headers: headers,
            }
        );
    }


    public chatSearch(keyword, tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('keyword', keyword);
        params = params.append('tv_communication', tv_communication.toString());

        return this.http.get(this.apiBase + '/search_artist/', {
            params: params,
            headers: headers,
        });
    }


    public artistSearch(keyword, tv_communication = false): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("keyword", keyword);

        return this.http.get(this.apiBase + "/search_artist_v2/", {
            params: params,
            headers: headers,
        });
    }

    public searchArtist(artistname: any, offset: any, limit: any): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        var localapi =
            "/artist_listing_search/?keyword=" +
            artistname +
            "&offset=" +
            offset +
            "&limit=" +
            limit;
        return this.http.get(this.apiArtistListing + localapi, {
            headers: headers,
        });
    }
    public search(keywords): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('keywords', keywords);

        return this.http.get(this.apiBase + '/sdsearch/', {
            params: params,
            headers: headers,
        });
    }
    /**********  Language Filter API  **********/
    public LanguageFilter(): any {
        let headers = new HttpHeaders().set("Autorization", this.user.token);
        let params = new HttpParams();
        return this.http.get(this.apiBase + "/language/?type=", {});
    }

    //  Search City By Keyword..
    public searchCityies(keywords: any): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        var localapi = "/artist_city_filter/?keyword=" + keywords;
        return this.http.get(this.apiBase + localapi, {
            // headers: headers,
        });
    }

    public ArtistListing(offset: any, limit: any): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        var localurl =
            "/artist_listing/?language=&genre=pop&purpose=&city=&keyword=&offset=" +
            offset +
            "&limit=" +
            limit;
        return this.http.get(this.apiArtistListing + localurl, {
            params: params,
            headers: headers,
        });
    }

    public ArtistListingFilterApi(
        languge: any,
        genre: any,
        purpose: any,
        city: any,
        keyword: any,
        offset: any,
        limit: any
    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        var localurl =
            "/artist_listing/?language=" +
            languge +
            "&genre=" +
            genre +
            "&purpose=" +
            purpose +
            "&city=" +
            city +
            "&keyword=" +
            keyword +
            "&offset=" +
            offset +
            "&limit=" +
            limit;
        return this.http.get(this.apiArtistListing + localurl, {
            params: params,
            headers: headers,
        });
    }

    public unreadMsgs(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/unread_messages_count/', {
            headers: headers,
        });
    }

    public unreadNotificationsCount(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/notification/unread/', {
            headers: headers,
        });
    }
    public hideNotification(notification_id): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/notification/hide/',
            {
                notification_id: notification_id,
            },
            {
                headers: headers,
            }
        );
    }
    public toggleReadNotification(notification_id): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/notification/toggle_read_unread/',
            {
                notification_id: notification_id,
            },
            {
                headers: headers,
            }
        );
    }
    public readAllNotifications(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/notification/mark_all_read/',
            {
                user_slug: this.user.slug,
            },
            {
                headers: headers,
            }
        );
    }

    public searchFull(keywords, type): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('keywords', keywords);
        params = params.append('type', type);

        return this.http.get(this.apiBase + '/sdsearch-listing/', {
            params: params,
            headers: headers,
        });
    }

    public searchByType(keywords, type, offset = 0, limit = 10): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('keywords', keywords);
        params = params.append('type', type);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/sdsearch-by-type/', {
            params: params,
            headers: headers,
        });
    }

    public getSpotlight(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/spotlight/', {
            headers: headers,
        });
    }

    public getFeeds(offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/feeds/', {
            params: params,
            headers: headers,
        });
    }

    public getBlogs(offset = 0, limit = 20, category = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('category', category);

        return this.http.get(this.apiBase + '/blogs/', {
            params: params,
            headers: headers,
        });
    }
    public getBlog(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();

        return this.http.get(this.apiBase + '/blog_detail/' + slug + '/', {
            params: params,
            headers: headers,
        });
    }
    public getBlogCategories(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();

        return this.http.get(this.apiBase + '/category-list/', {
            params: params,
            headers: headers,
        });
    }

    public getAlbumBlogs(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('slug', slug);

        return this.http.get(this.apiBase + '/album_blogs/', {
            params: params,
            headers: headers,
        });
    }
    public getArtistBlogs(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/artist_blogs/', {
            headers: headers,
        });
    }
    public getCat1Blogs(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/dashboard/blogs/', {
            headers: headers,
        });
    }

    public checkEmail(email): any {
        return this.http.post(this.apiBase + '/registration/is_email_exists/', {
            email: email,
            user_id: this.user.id,
        });
    }

    public checkUsername(username): any {
        return this.http.post(
            this.apiBase + '/registration/is_username_exists/',
            {
                username: username,
                user_id: this.user.id,
            }
        );
    }


    public register(
        formSteps,
        regType,
        formValue,
        register_from = 0,
        access_token,
        provider,

    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(

            this.apiBaseRegister + "/registration/save/",
            {
                formType: formSteps,
                register_type: regType,
                formData: formValue,
                register_from: register_from,
                access_token: access_token,
                provider: provider,
                source: "web",
            },
            {
                headers: headers,
            }
        );
    }

    public convertToArtist(
        genre,
        artistType,
        fname = this.user.fname,
        lname = this.user.lname,
        mobile = this.user.mobile,
        email = this.user.email,
        username = this.user.slug,
        country = '',
        state = '',
        city = ''
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/listener_to_artist/',
            {
                fname: fname,
                lname: lname,
                email: email,
                genre: [genre],
                username: username,
                mob: mobile,
                country: country,
                state: state,
                city: city,
                artist_category: artistType,
            },
            {
                headers: headers,
            }
        );
    }
    public convertToArtistV2(
        genre,
        artistType,
        fname = this.user.fname,
        lname = this.user.lname,
        mobile = this.user.mobile,
        email = this.user.email,
        username = this.user.slug,
        country = "",
        state = "",
        city = ""
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/v2/listener_to_artist/',
            {
                fname: fname,
                lname: lname,
                email: email,
                // genre: [genre],
                username: username,
                mob: mobile,
                country: country,
                state: state,
                city: city,
                artist_category: artistType,
            },
            {
                headers: headers,
            }
        );
    }


    public convertToArtistAuto(genre, artistType): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        this.http
            .post(
                this.apiBase + '/listener_to_artist/',
                {
                    genre: genre,
                    artist_category: artistType,
                },
                {
                    headers: headers,
                }
            )
            .subscribe((res) => {
                // console.log('Conversion Response: ', res);
                this.user.type = 'Artist';
                this.user.genre = [genre];
                this.user.artistType = artistType;
                this.user.status = 1;

                localStorage.setItem('type', JSON.stringify(this.user.type));
                localStorage.setItem('genre', JSON.stringify(this.user.genre));
                localStorage.setItem(
                    'artistType',
                    JSON.stringify(this.user.artistType)
                );
            });
    }

    public freeDownload(url): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        this.http
            .post(
                this.apiBase + '/track_free_download/',
                {
                    item_url: url,
                    album_id: url,
                    song_id: url,
                },
                {
                    headers: headers,
                }
            )
            .subscribe((res) => {
                // console.log('Free Download API Response: ', res);
            });
    }

    toolTracking(type, slug, tool, action = '') {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = {};
        if (type == 'album') {
            params = {
                media_type: 'album',
                media_slug: slug,
                tool_name: tool,
                action: action,
            };
        } else {
            params = {
                media_type: 'song',
                media_slug: slug,
                tool_name: tool,
                action: action,
            };
        }
        return this.http.post(this.apiBase + '/tooltrack/', params, {
            headers: headers,
        });
    }

    public contact(name, email, mobile, message, oppCategory, recaptcha): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        if (!oppCategory) {
            return this.http.post(
                this.apiBase + '/contact/',
                {
                    name: name,
                    email: email,
                    mobile: mobile,
                    message: message,
                    recaptcha: recaptcha,
                },
                {
                    headers: headers,
                }
            );
        } else {
            return this.http.post(
                this.apiBase + '/opportunity_lead_contactus/',
                {
                    oppor_cat: oppCategory,
                    name: name,
                    email: email,
                    mobile: +mobile,
                    message: message
                },
                {
                    headers: headers,
                }
            );
        }
    }

    public collegeContact(
        name,
        email,
        mobile,
        college,
        message,
        recaptcha
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/contact/campus_idol',
            {
                name: name,
                email: email,
                mobile: mobile,
                college: college,
                message: message,
                recaptcha: recaptcha,
            },
            {
                headers: headers,
            }
        );
    }

    public reportAbuse(
        url,
        complaint,
        description,
        name,
        email,
        mobile,
        recaptcha
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/report_abuse/',
            {
                url: url,
                complaint: complaint,
                description: description,
                name: name,
                email: email,
                mobile: mobile,
                recaptcha: recaptcha,
            },
            {
                headers: headers,
            }
        );
    }


    public contactBranding(
        name,
        email,
        mobile,
        message,
        recaptcha,
        company_name = '',
        company_industry = '',
        creation_type = ''
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/contact_branding/',
            {
                name: name,
                email: email,
                mobile: mobile,
                message: message,
                recaptcha: recaptcha,
                company_name: company_name,
                company_industry: company_industry,
                creation_type: creation_type,
            },
            {
                headers: headers,
            }
        );
    }

    public contactBrandPages(
        name,
        email,
        mobile,
        company_name = '',
        brief = '',
        page = ''
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/contact_pages/',
            {
                name: name,
                email: email,
                mobile: mobile,
                company_name: company_name,
                brief: brief,
                page: page,
            },
            {
                headers: headers,
            }
        );
    }

    public getSocialLinks(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/change_social_links/', {
            headers: headers,
        });
    }
    public updateSocialLinks(insta, fb, twitter, yt): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/change_social_links/',
            {
                instagram: 'https://instagram.com/' + insta,
                facebook: 'https://facebook.com/' + fb,
                twitter: 'https://twitter.com/' + twitter,
                youtube: 'https://youtube.com/' + yt,
            },
            {
                headers: headers,
            }
        );
    }
    public updatePersonalDetails(
        first_name,
        last_name,
        genre,
        slug,
        country,
        state,
        city,
        artist_type
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/personal_details/',
            {
                first_name: first_name,
                last_name: last_name,
                genre: genre,
                slug: slug,
                country: country,
                state: state,
                city: city,
                artist_type: artist_type,
            },
            {
                headers: headers,
            }
        );
    }
    public getEmail(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/change_user_email/', {
            headers: headers,
        });
    }
    public changeUrl(user_id, slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/change_url/",
            {
                slug: slug,
                user_id: user_id
            },
            {
                headers: headers
            }
        );
    }
    public updateEmail(email): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/change_user_email/',
            {
                email: email,
            },
            {
                headers: headers,
            }
        );
    }
    public getMobile(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/change_user_mobile/', {
            headers: headers,
        });
    }
    public updateMobile(mobile): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/change_user_mobile/',
            {
                mobile: mobile,
            },
            {
                headers: headers,
            }
        );
    }

    public getSubscriptionStatus(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(
            this.apiBase + '/change_newsletter_subscription/',
            {
                headers: headers,
            }
        );
    }
    public subscribeToNewsletter(is_subscribed): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/change_newsletter_subscription/',
            {
                is_subscribed: is_subscribed,
            },
            {
                headers: headers,
            }
        );
    }

    public addToCart(sku): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.angularBase + '/shopping-cart/index.php',
            {
                user_slug: this.user.slug,
                product_sku: sku,
                action: 'add',
            },
            {
                headers: headers,
            }
        );
    }

    public myCart(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.angularBase + '/shopping-cart/index.php',
            {
                user_slug: this.user.slug,
                action: 'mycart',
            },
            {
                headers: headers,
            }
        );
    }

    public removeFromCart(sku): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.angularBase + '/shopping-cart/index.php',
            {
                user_slug: this.user.slug,
                product_sku: sku,
                action: 'remove',
            },
            {
                headers: headers,
            }
        );
    }

    public payment(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.angularBase + '/shopping-cart/index.php',
            {
                user_slug: this.user.slug,
                action: 'payment',
            },
            {
                headers: headers,
            }
        );
    }

    public applyCoupon(code): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.angularBase + '/shopping-cart/index.php',
            {
                user_slug: this.user.slug,
                code: code,
                action: 'apply_coupon',
            },
            {
                headers: headers,
            }
        );
    }

    public removeCoupon(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.angularBase + '/shopping-cart/index.php',
            {
                user_slug: this.user.slug,
                action: 'remove_coupon',
            },
            {
                headers: headers,
            }
        );
    }

    public getPlaylists(type, offset, limit): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('type', type);
        params = params.append('offset', offset);
        params = params.append('limit', limit);

        return this.http.get(this.apiBase + '/playlist/songdew_playlists/', {
            params: params,
            headers: headers,
        });
    }

    public getPlaylistsV2(type, offset, limit, page = ""): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("type", type);
        params = params.append("offset", offset);
        params = params.append("limit", limit);
        params = params.append("page", page);
        return this.http.get(this.apiBaseV2 + "/playlist/songdew_playlists/", {
            params: params,
            headers: headers,
        });
    }

    public getPlaylistsV3(type, offset, limit): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('type', type);
        params = params.append('offset', offset);
        params = params.append('limit', limit);

        return this.http.get(this.apiBase + '/v3/playlist/songdew_playlists/', {
            params: params,
            headers: headers,
        });
    }

    public getQueue(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/playlist/queue/1549/', {
            params: params,
            headers: headers,
        });
    }

    public showPlaylists(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_id', this.user.id);

        return this.http.get(this.apiBase + '/playlist/user_playlists', {
            params: params,
            headers: headers,
        });
    }

    public createPlaylist(playlistName, privacy, song_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/playlist/create/',
            {
                playlist_name: playlistName,
                privacy: privacy,
                song_slug: song_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public addToPlaylist(song_slug, playlist_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/playlist/add_track/',
            {
                song_slug: song_slug,
                playlist_slug: playlist_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public editPlaylist(
        playlist_slug,
        name,
        privacy,
        image,
        is_default,
        trackSlugs = []
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/playlist/edit_playlist/',
            {
                playlist_slug: playlist_slug,
                title: name,
                privacy: privacy,
                status: !privacy,
                image: image,
                is_default: is_default,
                track_slugs_in_order: trackSlugs,
            },
            {
                headers: headers,
            }
        );
    }
    public shufflePlaylist(playlist_slug, trackSlugs = []): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/playlist/change_order/',
            {
                playlist_slug: playlist_slug,
                track_slugs_in_order: trackSlugs,
            },
            {
                headers: headers,
            }
        );
    }

    public deletePlaylist(playlist_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/playlist/delete_playlist/',
            {
                playlist_slug: playlist_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public deletePlaylistTrack(playlist_slug, song_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/playlist/delete_track/',
            {
                playlist_slug: playlist_slug,
                song_slug: song_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public getPlaylistDetails(playlist_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('playlist_slug', playlist_slug);

        return this.http.get(
            this.apiBase + '/playlist/playlist_detail/' + playlist_slug + '/',
            {
                params: params,
                headers: headers,
            }
        );
    }

    public getBadges(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);

        return this.http.get(this.apiBase + '/user_opportunity_badges/', {
            params: params,
            headers: headers,
        });
    }

    public getUserSongs(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/usersongs/', {
            params: params,
            headers: headers,
        });
    }
    public getUserVideos(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/uservideos/', {
            params: params,
            headers: headers,
        });
    }

    public checkYoutubeUrl(youtubeUrl: string): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        const params = new HttpParams().set('youtube_videoid', youtubeUrl);
        return this.http.get(this.apiBase + '/check_youtube_url/', { params, headers });
    }

    public getPlayerSong(song_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('song_slug', song_slug);

        return this.http.get(this.apiBase + '/song_player/', {
            params: params,
            headers: headers,
        });
    }

    public getSongs(
        type,
        lang,
        genre,
        offset = 0,
        limit = 20,
        pseudoSongs = false,
        from = type,
        version = 1
    ): any {
        if (type == 'new') {
            type = 'fresh';
        } else if (type == 'best') {
            type = 'recommended';
        }

        if (lang == 'all_languages') {
            lang = '';
        }

        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('type', type);
        params = params.append('language', lang);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('komal', '1');
        // params = params.append('all', '1');
        if (pseudoSongs) {
            params = params.append('more', '1');
            params = params.append('from', from);
        }

        // console.log(genre);
        genre.forEach((genreName) => {
            if (genreName == 'all_genres') {
                genreName = '';
            }
            params = params.append('genre', genreName);
        });
        if (version == 2 && type !== 'fresh') {
            return this.http.get(this.apiBase + '/v2/songs-listing/' + type + '/', {
                params: params,
                headers: headers,
            });
        } else {

            return this.http.get(this.apiBase + '/songs-listing/' + type + '/', {
                params: params,
                headers: headers,
            });
        }
    }

    public getFeaturedArtist(offset = 0, limit = 4): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/featured_artist', {
            params: params,
            headers: headers,
        });
    }

    public getSongDetails(slug, show_private = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('slug_usersong', slug);
        params = params.append('show_private', show_private.toString());

        return this.http.get(this.apiBase + '/song/', {
            params: params,
            headers: headers,
        });
    }
    public getPromoSongDetails(slug, show_private = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('slug_usersong', slug);
        params = params.append('show_private', show_private.toString());

        return this.http.get(this.apiBase + '/promo_song_detail/', {
            params: params,
            headers: headers,
        });
    }
    public getPromoAlbumDetails(slug, show_private = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('album_slug', slug);
        params = params.append('show_private', show_private.toString());

        return this.http.get(this.apiBase + '/promo_album_details/', {
            params: params,
            headers: headers,
        });
    }


    public publishAlbum(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('album_slug', slug);

        return this.http.post(
            this.apiBase + '/album-publish/',
            {
                albumid: slug,
                user_id: this.user.id,
            },
            {
                headers: headers,
            }
        );
    }
    public getAlbumDetails(slug, show_private = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('album_slug', slug);
        params = params.append('show_private', show_private.toString());

        return this.http.get(this.apiBase + '/album_details/', {
            params: params,
            headers: headers,
        });
    }
    public toolunlock(type, slug) {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('album_slug', slug);
        params = params.append('media_slug', slug);
        params = params.append('media_type', type);

        return this.http.get(this.apiBase + '/toolunlock/', {
            params: params,
            headers: headers,
        });
    }
    public tooldetail(promo_type) {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + "/tool_detail/" + promo_type, {
            headers: headers,
        });
    }

    public getSongComments(song_slug, offset = 0, limit = 5): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('song_slug', song_slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/song_comments/', {
            params: params,
            headers: headers,
        });
    }
    public getAlbumComments(album_slug, offset = 0, limit = 5): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('album_slug', album_slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/album_reviews/', {
            params: params,
            headers: headers,
        });
    }
    public getPlaylistComments(album_slug, offset = 0, limit = 5): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("album_slug", album_slug);
        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());

        return this.http.get(this.apiBase + "/playlist_reviews/", {
            params: params,
            headers: headers,
        });
    }
    public getVideoComments(video_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('video_slug', video_slug);

        return this.http.get(this.apiBase + '/video_comments/', {
            params: params,
            headers: headers,
        });
    }
    public getBlogComments(blog_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('blog_slug', blog_slug);

        return this.http.get(this.apiBase + '/blog_comments/', {
            params: params,
            headers: headers,
        });
    }
    public sendComment(song_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/song_comments/',
            {
                song_slug: song_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public albumReview(album_slug, review, parent, star_ratings): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/album_reviews/',
            {
                album_slug: album_slug,
                review: review,
                parent: null,
                star_ratings: star_ratings,
            },
            {
                headers: headers,
            }
        );
    }
    public albumReply(album_slug, review, parent): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/album_reviews/',
            {
                album_slug: album_slug,
                review: review,
                parent: parent,
            },
            {
                headers: headers,
            }
        );
    }
    public songReview(song_slug, review, parent, star_ratings): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/song_comments/',
            {
                song_slug: song_slug,
                comment: review,
                parent: null,
                star_ratings: star_ratings,
            },
            {
                headers: headers,
            }
        );
    }
    public songReply(song_slug, review, parent): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/song_comments/",
            {
                song_slug: song_slug,
                comment: review,
                parent: parent,
            },
            {
                headers: headers,
            }
        );
    }
    public playlistReview(song_slug, review, parent, star_ratings): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/playlist_reviews/",
            {
                song_slug: song_slug,
                comment: review,
                parent: null,
                star_ratings: star_ratings,
            },
            {
                headers: headers,
            }
        );
    }
    public playlistReply(song_slug, review, parent): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/playlist_reviews/",
            {
                song_slug: song_slug,
                comment: review,
                parent: parent,
            },
            {
                headers: headers,
            }
        );
    }

    public videoReview(video_slug, review, parent, star_ratings): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/video_comments/',
            {
                video_slug: video_slug,
                comment: review,
                parent: null,
                star_ratings: star_ratings,
            },
            {
                headers: headers,
            }
        );
    }
    public videoReply(video_slug, review, parent): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/video_comments/',
            {
                video_slug: video_slug,
                comment: review,
                parent: parent,
            },
            {
                headers: headers,
            }
        );
    }

    public blogReview(blog_slug, review, parent, star_ratings): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/blog_comments/',
            {
                blog_slug: blog_slug,
                comment: review,
                parent: null,
                star_ratings: star_ratings,
            },
            {
                headers: headers,
            }
        );
    }
    public blogReply(blog_slug, review, parent): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/blog_comments/',
            {
                blog_slug: blog_slug,
                comment: review,
                parent: parent,
            },
            {
                headers: headers,
            }
        );
    }

    public editSongDetails(
        slug,
        title,
        language,
        genre,
        mood,
        tags,
        description,
        composer,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        other_release_date = release_date
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.put(
            this.apiBase + '/song/',
            {
                slug_usersong: slug,
                title: title,
                language: [language],
                genre: [genre],
                mood: [mood],
                tags: tags,
                description: description,
                composer: composer,
                privacy: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                other_release_date: other_release_date,
            },
            {
                headers: headers,
            }
        );
    }



    public editSongDetailsV2(
        slug,
        title,
        language,
        genre,
        yearValue,
        featuredArtist,
        lyrics,
        mood,
        tags,
        description,

        lyricist,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        other_release_date = release_date,
        primaryArtist,
        composer,
        author,
        producer,
        arranger,
        remixer,
        for_opp = false,
        presave = false,

    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.put(
            this.apiBase + "/song/",

            {
                slug_usersong: slug,
                title: title,
                language: [language],
                genre: [genre],
                yearValue: yearValue,
                featured_artists: featuredArtist,
                lyrics: lyrics,
                mood: [mood],
                tags: tags,
                description: description,
                lyricist: lyricist,
                privacy: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                other_release_date: other_release_date,
                primaryArtist: primaryArtist,
                composer: composer,
                author: author,
                producer: producer,
                arranger: arranger,
                remixer: remixer,
            },
            {
                headers: headers,
            }
        );
    }

    public deleteSong(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('slug_usersong', slug);

        return this.http.delete(this.apiBase + '/song/', {
            params: params,
            headers: headers,
        });
    }

    public getVideos(type, lang, genre, offset = 0, limit = 20): any {
        if (type == 'best' || type == 'recommended') {
            type = 'select';
        }

        if (lang == 'all_languages') {
            lang = '';
        }

        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('type', type);
        params = params.append('language', lang);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        // console.log(genre);
        genre.forEach((genreName) => {
            if (genreName == 'all_genres') {
                genreName = '';
            }
            params = params.append('genre', genreName);
        });

        return this.http.get(this.apiBase + '/songdewvideos/', {
            params: params,
            headers: headers,
        });
    }


    public getSDLink(slugId) {
        let params = new HttpParams();
        params = params.append('slug', slugId);
        return this.http.get(this.apiBase + '/sdLink/', {
            params,
        })
    }

    public postSDLinkPresaveUser(userInfo, slug, type) {
        return this.http.post(
            this.apiBase + '/sdLink/save',
            {
                userInfo,
                slug,
                type,
            },
        );
    }

    public updateSDLinkPlatforms(payload: { slug: string; links: { [key: string]: string } }) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(
            this.apiBase + '/sdLink/update-platforms',
            JSON.stringify(payload),
            { headers }
        );
    }

    public trackSDLinkClick(payload: { slug: string; platform: string }) {
        return this.http.post(this.apiBase + '/sdLink/track-click', payload);
    }

    public getSDLinkAnalytics(slug: string) {
        const params = new HttpParams().set('slug', slug);
        return this.http.get(this.apiBase + '/sdLink/analytics', { params });
    }



    public getAICompletions(text: string, key: string) {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return this.http.post(
            'https://sdai.songdew.com/' + 'epk/', {
            text,
            key
        }, {
            headers: headers
        }
        )
    }


    public getMusicVideoList(
        type,
        lang,
        genre,
        offset = 0,
        limit = 20,
        pseudoSongs = false,
        from = type
    ): any {
        if (type == "new") {
            type = "fresh";
        } else if (type == "best" || type == "recommended") {
            type = "recommended";
        }

        if (lang == "all_languages") {
            lang = "";
        }

        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("type", type);
        params = params.append("language", lang);
        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());
        params = params.append("komal", "1");
        // params = params.append('all', '1');
        if (pseudoSongs) {
            params = params.append("more", "1");
            params = params.append("from", from);
        }

        // console.log(genre);
        genre.forEach((genreName) => {
            if (genreName == "all_genres") {
                genreName = "";
            }
            params = params.append("genre", genreName);
        });

        return this.http.get(this.apiBase + "/v2/songdewvideos/" + type + "/", {
            params: params,
            headers: headers,
        });

    }



    public getVideoDetails(slug, show_private = 0): any {
        let params = new HttpParams();
        params = params.append("slug_uservideo", slug);
        params = params.append("show_private", show_private.toString());
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.get(this.apiBase + "/video/", { params: params, headers: headers });
    }

    public editVideoDetails(
        slug,
        youtubeUrl,
        title,
        language,
        genre,
        mood,
        tags,
        privacy,
        submitToTv
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.put(
            this.apiBase + '/video/',
            {
                slug_uservideo: slug,
                youtube_url: youtubeUrl,
                title: title,
                language: [language],
                genre: [genre],
                mood: [mood],
                tags: tags,
                is_public: !privacy,
                is_submit_tv: submitToTv,
            },
            {
                headers: headers,
            }
        );
    }

    public deleteVideo(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('slug_uservideo', slug);

        return this.http.delete(this.apiBase + '/video/', {
            params: params,
            headers: headers,
        });
    }

    public advertisement(type = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        if (type == '') {
            type = 'content';
        }

        return this.http.get(this.apiBase + '/tools/' + type, {
            params: params,
            headers: headers,
        });

    }

    public getAudioPromo(album_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('album_slug', album_slug);

        return this.http.get(this.apiBase + '/album/promo_video/', {
            params: params,
            headers: headers,
        });
    }

    public getInstaStory(album_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('slug_album', album_slug);

        return this.http.get(this.apiBase + '/album/instastory/', {
            params: params,
            headers: headers,
        });
    }

    public getVideoPromo(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(this.apiBase + '/promo/', {
            params: params,
            headers: headers,
        });
    }

    public d2hOpportunities(user_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        // params = params.append('user_slug', 'kchandra.p');
        params = params.append('user_slug', user_slug);
        params = params.append('offset', '0');
        params = params.append('limit', '10');

        return this.http.get(this.apiBase + '/profile_opportunities_d2h/', {
            params: params,
            headers: headers,
        });
    }

    public savePreviewCampaignMsg(album_slug, type = 'album', msg = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.post(
            this.apiBase + '/save_preview_campaign_message/',
            {
                album_slug: album_slug,
                song_slug: album_slug,
                type: type,
                is_album: type == 'album' ? true : false,
                message: msg,
            },
            {
                headers: headers,
            }
        );
    }

    public requestCode(album_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/tools/coupon',
            {
                album_slug: album_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public activatePromotion(album_slug, promotion_type = "campanion", is_album, agreement = 0): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + '/tools/button',
            {
                album_slug: album_slug,
                promotion_type: promotion_type,
                is_album: is_album,
                agreement: agreement,
            },
            {
                headers: headers,
            }
        );
    }

    public changePwd(npwd, cpwd, type = 'old', opwd = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        if (type == 'old') {
            return this.http.post(
                this.apiBase + '/songdewuser/change_password/',
                {
                    old_password: opwd,
                    new_password: npwd,
                    confirm_new_password: cpwd,
                },
                {
                    headers: headers,
                }
            );
        } else {
            return this.http.post(
                this.apiBase + '/songdewuser/change_password/',
                {
                    new_password: npwd,
                    confirm_new_password: cpwd,
                },
                {
                    headers: headers,
                }
            );
        }
    }

    public changeDp(dp): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/update_profile_cover_pic/',
            {
                image_type: 'profile',
                image: dp,
            },
            {
                headers: headers,
            }
        );
    }

    public deleteAccount(data: any): Observable<any> {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(this.apiBase + "/songdewuser/delete_account/",
            {
                reason: data
            },
            {
                headers: headers,
            })
    }

    public uploadSong(frmData, for_opp = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        frmData.append('user_id', this.user.id);
        frmData.append('for_opp', for_opp);

        return this.http.post(this.apiBase + '/uploadsong/', frmData, {
            reportProgress: true,
            observe: 'events',
            headers: headers,
        });
    }

    public uploadTechrider(frmData): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        frmData.append('user_id', this.user.id);

        return this.http.post(this.apiBase + '/techrider/', frmData, {
            reportProgress: true,
            observe: 'events',
            headers: headers,
        });
    }
    public getTechrider(artist_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('artist_slug', artist_slug);

        return this.http.get(this.apiBase + '/techrider/', {
            params: params,
            headers: headers,
        });
    }
    public deleteTechrider(file): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.post(
            this.apiBase + '/techrider/delete/',
            {
                artist_slug: this.user.slug,
                file: file,
            },
            {
                headers: headers,
            }
        );
    }
    public deleteGigKitImage(file): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.post(
            this.apiBase + '/gigkitimage/delete/',
            {
                artist_slug: this.user.slug,
                file: file,
            },
            {
                headers: headers,
            }
        );
    }
    public changeGigKitImage(image): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/update_profile_cover_pic/',
            {
                image_type: 'techrider_gallery',
                image: image,
            },
            {
                headers: headers,
            }
        );
    }

    public scheduleFormSubmit(
        form_step,
        privacy,
        is_public,
        is_scheduled,
        release_date,
        other_release_date,
        downloadable,
        album_id,


    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/upload_albums/",
            {
                form_step: form_step,
                privacy: privacy,
                is_public: is_public,
                is_scheduled: is_scheduled,
                release_date: release_date,
                other_release_date: other_release_date,
                is_downloadable: downloadable,
                album_id: album_id,
            },
            {
                headers: headers,
            }
        );
    }
    public albumArtUpload(
        form_step,
        image,
        album_id,
    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/upload_albums/",
            {
                form_step: form_step,
                image: image,
                album_id: album_id,
            },
            {
                headers: headers,
            }
        );
    }


    public uploadAlbumTrack(frmData): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        frmData.append('user_id', this.user.id);

        return this.http.post(this.apiBase + '/songupload/', frmData, {
            reportProgress: true,
            observe: 'events',
            headers: headers,
        });
    }

    public uploadOppSong(frmData, slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        frmData.append('user_id', this.user.id);
        frmData.append('oppor_slug', slug);

        return this.http.post(
            this.apiBase + '/opportunity_apply_upload_songs_1/',
            frmData,
            {
                reportProgress: true,
                observe: 'events',
                headers: headers,
            }
        );
    }


    public sendAlbumReleaseDetails(
        album_slug,
        form_step,
        song_title,
        version,
        record_label,
        featuredartist,



    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        if (album_slug == '' || album_slug == undefined) {
            return this.http.post(
                this.apiBase + "/upload_albums/",
                {
                    slug: album_slug,
                    form_step: form_step,
                    title: song_title,
                    version: version,
                    label: record_label,
                    featured_artists: featuredartist,
                },
                {
                    headers: headers,
                }
            );
        } else {
            return this.http.put(
                this.apiBase + "/upload_albums/",
                {
                    slug: album_slug,
                    form_step: form_step,
                    title: song_title,
                    version: version,
                    label: record_label,
                    featured_artists: featuredartist,
                },
                {
                    headers: headers,
                }
            );
        }

    }




    public sendAlbumDetails(
        title,
        language,
        genre,
        description,
        tags,
        record_label,
        privacy,
        release_date,
        downloadable,
        buylink,
        image,
        other_release_date = release_date
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/uploadalbums/',
            {
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                description: description,
                tags: tags,
                record_label: record_label,
                privacy: privacy,
                release_date: release_date,
                is_downloadable: downloadable,
                buylink: buylink,
                image: image,
                other_release_date: other_release_date,
            },
            {
                headers: headers,
            }
        );
    }

    public deleteAlbum(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('albumid', slug);
        params = params.append('user_id', this.user.id);

        return this.http.delete(this.apiBase + '/album-delete/', {
            params: params,
            headers: headers,
        });
    }

    public editAlbumDetails(
        album_id,
        title,
        language,
        genre,
        description,
        tags,
        record_label,
        privacy,
        release_date,
        downloadable,
        buylink,
        image,
        other_release_date = release_date
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.put(
            this.apiBase + '/uploadalbums/',
            {
                albumid: album_id,
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                description: description,
                tags: tags,
                record_label: record_label,
                privacy: privacy,
                release_date: release_date,
                is_downloadable: downloadable,
                buylink: buylink,
                image: image,
                other_release_date: other_release_date,
            },
            {
                headers: headers,
            }
        );
    }

    public sendAlbumTrackDetails(
        album_id,
        musicfile,
        title,
        language,
        genre,
        description,
        mood,
        tags,
        composer
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/uploadmusic/',
            {
                user_id: this.user.id,
                album_id: album_id,
                uploadedfile: musicfile,
                title: title,
                language: language,
                genre: [genre],
                description: description,
                mood: [mood],
                tags: tags,
                composer: composer,
            },
            {
                headers: headers,
            }
        );
    }

    public sendAlbumTrackDetailsV2(
        album_id,
        musicfile,
        title,
        language,
        genre,
        yearOfProduction,
        featuredartist,
        lyrics,
        lyricist,
        description,
        mood,
        tags,
        primaryArtist,
        composer,
        author,
        producer,
        arranger,
        remixer,
        duration
    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/uploadmusic/",
            {

                albumid: album_id,
                lyrics: lyrics,
                lyricist: lyricist,
                yearOfProduction: yearOfProduction,
                featured_artists: featuredartist,
                uploadedfile: musicfile,
                title: title,
                language: [language],
                genre: [genre],
                description: description,
                mood: [],
                tags: tags,
                primaryArtist: primaryArtist,
                composer: composer,
                author: author,
                producer: producer,
                arranger: arranger,
                remixer: remixer,
                duration: duration
            },
            {
                headers: headers,
            }
        );
    }




    public EditAlbumTrackDetails(
        album_id,
        song_id,
        // musicfile,
        title,
        language,
        genre,
        yearOfProduction,
        featuredartist,
        lyrics,
        lyricist,
        description,
        mood,
        tags,
        primaryArtist,
        composer,
        author,
        producer,
        arranger,
        remixer,
    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        if (song_id == '' || song_id == undefined) {
            return this.http.post(
                this.apiBase + "/uploadmusic/",
                {

                    albumid: album_id,
                    songid: song_id,
                    lyrics: lyrics,
                    lyricist: lyricist,
                    yearOfProduction: yearOfProduction,
                    featured_Artists: featuredartist,
                    title: title,
                    language: [language],
                    genre: [genre],
                    description: description,
                    mood: [],
                    tags: '',
                    primaryArtist: primaryArtist,
                    composer: composer,
                    author: author,
                    producer: producer,
                    arranger: arranger,
                    remixer: remixer,
                },
                {
                    headers: headers,
                }
            );
        } else {
            return this.http.put(
                this.apiBase + "/uploadmusic/",
                {

                    albumid: album_id,
                    songid: song_id,
                    lyrics: lyrics,
                    lyricist: lyricist,
                    yearOfProduction: yearOfProduction,
                    featured_Artists: featuredartist,
                    title: title,
                    language: [language],
                    genre: [genre],
                    description: description,
                    mood: [],
                    tags: '',
                    primaryArtist: primaryArtist,
                    composer: composer,
                    author: author,
                    producer: producer,
                    arranger: arranger,
                    remixer: remixer
                },
                {
                    headers: headers,
                }
            );
        }

    }



    public sendSongDetailsV3(
        uploadedfile,
        title,
        language,
        genre,
        yearValue,
        featuredArtist,
        lyrics,
        mood,
        tags,
        description,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        other_release_date = release_date,
        slug,
        primaryArtistName,
        composerName,
        authorName,
        producerName,
        arrangerName,
        remixerName,
        for_opp = false,
        presave = false,

    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/uploadsongdetails/",
            {
                slug_usersong: slug,
                uploadedfile: uploadedfile,
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                featured_artists: featuredArtist,
                lyrics: lyrics,
                mood: mood,
                tags: tags,
                description: description,
                primaryArtist: primaryArtistName,
                composer: composerName,
                author: authorName,
                producer: producerName,
                arranger: arrangerName,
                remixer: remixerName,
                production_year: yearValue,
                is_public: true,
                privacy: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                other_release_date: other_release_date,
                for_opp: for_opp,
                presave: presave,
            },
            {
                headers: headers,
            }
        );
    }

    public sendSongDetailsV2(
        uploadedfile,
        title,
        language,
        genre,
        yearValue,
        featuredArtist,
        lyrics,
        mood,
        tags,
        description,
        composer,
        lyricist,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        other_release_date = release_date,
        slug,
        for_opp = false,
        presave = false,

    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/uploadsongdetails/",
            {
                slug_usersong: slug,
                uploadedfile: uploadedfile,
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                featured_artists: featuredArtist,
                lyrics: lyrics,
                mood: mood,
                tags: tags,
                description: description,
                composer: composer,
                lyricist: lyricist,
                production_year: yearValue,
                is_public: true,
                privacy: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                other_release_date: other_release_date,
                for_opp: for_opp,
                presave: presave,
            },
            {
                headers: headers,
            }
        );
    }


    public sendSongDetails(
        uploadedfile,
        title,
        language,
        genre,
        mood,
        tags,
        description,
        composer,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        other_release_date = release_date,
        for_opp = false,
        presave = false
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/uploadsongdetails/',
            {
                uploadedfile: uploadedfile,
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                mood: [mood],
                tags: tags,
                description: description,
                composer: composer,
                privacy: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                other_release_date: other_release_date,
                for_opp: for_opp,
                presave: presave,
            },
            {
                headers: headers,
            }
        );
    }

    public sendOppSongDetailsV2(
        uploadedfile,
        title,
        language,
        genre,
        featuredArtist,
        lyrics,
        mood,
        tags,
        description,
        composer,
        lyricist,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        slug,
        radio_agreement,
        presave = false
    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        radio_agreement = radio_agreement ? 1 : 0;
        return this.http.post(
            this.apiBase + "/opportunity_apply_upload_songs_2/",
            {
                uploadedfile: uploadedfile,
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                lyrics: lyrics,
                mood: [mood],
                tags: tags,
                description: description,
                composer: composer,
                lyricist: lyricist,
                featured_artists: featuredArtist,
                is_public: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                oppor_slug: slug,
                radio_agreement: radio_agreement,
                presave: presave,
            },
            {
                headers: headers,
            }
        );
    }

    public uploadvideov2(
        youtubeUrl,
        title,
        language,
        genre,
        mood,
        tags,
        privacy,
        submitToTv,
        video_releaseds,
        cbfc_certificates,
        track_embeddeds,
        track_releaseds,
        usermessages,
        is_submit_websites,
        slug,
        songid
    ): any {

        // 
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        if (slug == '' || slug == undefined) {
            return this.http.post(
                this.apiBase + "/uploadvideov2/",
                {
                    user_id: this.user.id,
                    youtube_url: youtubeUrl,
                    title: title,
                    language: [language],
                    genre: [genre],
                    mood: [mood],
                    tags: tags,
                    is_public: privacy,
                    is_submit_tv: submitToTv,
                    video_released: video_releaseds,
                    cbfc_certificate: cbfc_certificates,
                    track_embedded: track_embeddeds,
                    track_released: track_releaseds,
                    is_submit_website: is_submit_websites,
                    usermessage: usermessages,
                    song_id: songid

                },
                {
                    headers: headers,
                }
            );
        } else {
            return this.http.put(
                this.apiBase + "/uploadvideov2/",
                {
                    user_id: this.user.id,
                    youtube_url: youtubeUrl,
                    title: title,
                    language: [language],
                    genre: [genre],
                    mood: [mood],
                    tags: tags,
                    is_public: privacy,
                    is_submit_tv: submitToTv,
                    video_released: video_releaseds,
                    cbfc_certificate: cbfc_certificates,
                    track_embedded: track_embeddeds,
                    track_released: track_releaseds,
                    is_submit_website: is_submit_websites,
                    usermessage: usermessages,
                    video_slug: slug
                },
                {
                    headers: headers,
                }
            );
        }

    }

    public sendOppSongDetails(
        uploadedfile,
        title,
        language,
        genre,
        mood,
        tags,
        description,
        composer,
        privacy,
        downloadable,
        record_label,
        release_date,
        buylink,
        image_type,
        image,
        slug,
        presave = false
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/opportunity_apply_upload_songs_2/',
            {
                uploadedfile: uploadedfile,
                user_id: this.user.id,
                title: title,
                language: [language],
                genre: [genre],
                description: description,
                mood: [mood],
                tags: tags,
                composer: composer,
                is_public: !privacy,
                privacy: privacy,
                is_downloadable: downloadable,
                record_label: record_label,
                release_date: release_date,
                buylink: buylink,
                is_default: image_type,
                image: image,
                oppor_slug: slug,
                presave: presave,
            },
            {
                headers: headers,
            }
        );
    }

    public getFPC(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/songdewtv/fpc', {
            headers: headers,
        });
    }

    public getDashboardStats(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(this.apiBase + '/dashboard/', {
            headers: headers,
        });
    }


    public getDashboardTodo(offset = 0, limit = 5): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());


        return this.http.get(this.apiBase + "/dashboard/todo/v3/", {
            params: params,
            headers: headers,
        });
    }

    // //////////////////// resume journey /////////////////////////////////////
    public getResumeJourney(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + "/dashboard/resume_journey", {
            headers: headers,
        });
    }
    // ///////////////////////////

    public getProfileCompletion(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(
            this.apiBase + '/songdewuser/profile_completion/',
            {
                headers: headers,
            }
        );
    }

    public clearPreUploadedSong(oppor_slug, uploadedfile): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/uploadsong/clear',
            {
                oppor_slug: oppor_slug,
                uploadedfile: uploadedfile,
            },
            {
                headers: headers,
            }
        );
    }

    public sendEmailVerificationLink(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/registration/send_account_activation_email/',
            {
                user_slug: this.user.slug,
            },
            {
                headers: headers,
            }
        );
    }
    public verifyEmail(slug1, slug2): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase +
            '/registration/activate_user_account/' +
            slug1 +
            '/' +
            slug2 +
            '/',
            {
                headers: headers,
            }
        );
    }
    public resetPassword(slug1, slug2, pwd1, pwd2): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase +
            '/registration/reset_user_account_password/' +
            slug1 +
            '/' +
            slug2 +
            '/',
            {
                new_password: pwd1,
                confirm_new_password: pwd2,
            },
            {
                headers: headers,
            }
        );
    }
    public forgotPwd(email): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('email', email);

        return this.http.get(
            this.apiBase + '/registration/send_forgot_password_reset_email/',
            {
                params: params,
                headers: headers,
            }
        );
    }

    public showAllChats(tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('tv_communication', tv_communication.toString());

        return this.http.get(this.apiBase + '/message_inbox/', {
            params: params,
            headers: headers,
        });
    }
    public showChat(user_id, tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('sender_id', user_id);
        params = params.append('tv_communication', tv_communication.toString());

        return this.http.get(this.apiBase + '/show_message/', {
            params: params,
            headers: headers,
        });
    }
    public sendMsg(username, body, tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/message_compose/',
            {
                receipient: username,
                body: body,
                tv_communication: tv_communication,
            },
            {
                headers: headers,
            }
        );
    }
    public unreadMsg(message_id, tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('message_id', message_id);
        params = params.append('tv_communication', tv_communication.toString());

        return this.http.get(this.apiBase + '/mark_message_unread/', {
            params: params,
            headers: headers,
        });
    }
    public deleteMsg(other_artist_id, tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/delete_message/',
            {
                other_artist_id: other_artist_id,
                tv_communication: tv_communication
            },
            {
                headers: headers,
            }
        );
    }
    public reportMsg(other_artist_id, tv_communication = false): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/report_abuse_message/',
            {
                other_artist_id: other_artist_id,
                tv_communication: tv_communication
            },
            {
                headers: headers,
            }
        );
    }

    public songAnalytics(song_slug, interval_duration, type = 'tracks'): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        if (type == 'tracks') {
            params = params.append('song_slug', song_slug);
            params = params.append('interval_duration', interval_duration);

            return this.http.get(this.apiBase + '/song_analytics/', {
                params: params,
                headers: headers,
            });
        } else if (type == 'videos') {
            params = params.append('video_slug', song_slug);
            params = params.append('interval_duration', interval_duration);

            return this.http.get(this.apiBase + '/video_analytics/', {
                params: params,
                headers: headers,
            });
        } else if (type == 'profile-views') {
            params = params.append('interval_duration', interval_duration);

            return this.http.get(this.apiBase + '/profile_views_analytics/', {
                params: params,
                headers: headers,
            });
        } else if (type == 'profile-following') {
            params = params.append('interval_duration', interval_duration);

            return this.http.get(
                this.apiBase + '/profile_following_analytics/',
                {
                    params: params,
                    headers: headers,
                }
            );
        }
    }

    public getLanguages(available = false, type = "", genre = [], music_type = ''): any {
        let params = new HttpParams();
        params = params.append("type", type);
        genre.forEach((genreName) => {
            if (genreName == "all_genres") {
                genreName = "";
            }
            params = params.append("genre", genreName);
        });
        if (music_type == 'video') {
            if (available) {
                return this.http.get(this.apiBase + "/v2/v-language-available/", {
                    params: params,
                });
            }

        } else {
            if (available) {
                return this.http.get(this.apiBase + "/language-available/", {
                    params: params,
                });
            } else {
                return this.http.get(this.apiBase + "/language/", {
                    params: params,
                });
            }
        }
    }

    public sendVideoDetails(
        youtubeUrl,
        title,
        language,
        genre,
        mood,
        tags,
        privacy,
        submitToTv
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/uploadvideo/',
            {
                user_id: this.user.id,
                youtube_url: youtubeUrl,
                title: title,
                language: [language],
                genre: [genre],
                mood: [mood],
                tags: tags,
                is_public: !privacy,
                is_submit_tv: submitToTv,
            },
            {
                headers: headers,
            }
        );
    }

    public sendOppVideoDetails(
        youtubeUrl,
        title,
        language,
        genre,
        mood,
        tags,
        privacy,
        submitToTv,
        slug
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/opportunity_apply_upload_videos/',
            {
                user_id: this.user.id,
                youtube_url: youtubeUrl,
                title: title,
                language: [language],
                genre: [genre],
                mood: [mood],
                tags: tags,
                is_public: !privacy,
                is_submit_tv: submitToTv,
                oppor_slug: slug,
            },
            {
                headers: headers,
            }
        );
    }

    public getAgreements(offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/agreement/list', {
            params: params,
            headers: headers,
        });
    }

    public getAgreementDetail(id): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('id', id.toString());

        return this.http.get(this.apiBase + '/agreement/detail', {
            params: params,
            headers: headers,
        });
    }

    public sendAgreementOTP(mob, agreement_id, sign): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/agreement/send_otp/',
            {
                mobile_number: mob,
                agreement_id: agreement_id,
                sign: sign,
                user_slug: this.user.slug,
                ip: this.user.ip.toString(),
            },
            {
                headers: headers,
            }
        );
    }

    public verifyAgreementOTP(otp, agreement_id, sign): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/agreement/verify_otp/',
            {
                otp: otp,
                agreement_id: agreement_id,
                sign: sign,
                user_slug: this.user.slug,
                ip: this.user.ip.toString(),
            },
            {
                headers: headers,
            }
        );
    }

    public getRHSOpportunities(oppor_slug, offset = 0, limit = 10): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('oppor_slug', oppor_slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/opportunity_rhs_new', {
            params: params,
            headers: headers,
        });
    }

    public getOpportunities(
        from = '',
        type,
        offset = 0,
        limit = 20,
        search = '',
        sort = '',
        is_dashboard = false,
        category = 2
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('oppor_type', type);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('keyword', search);
        params = params.append('sort_by', sort);

        if (is_dashboard) {
            params = params.append('is_dashboard', is_dashboard.toString());
        }
        params = params.append('category', category.toString());

        let path = '/opportunity-v2/';
        if (from == 'rhs') {
            path = '/opportunity_rhs/';
        } else if (from == 'upcoming') {
            path = '/opportunity_upcoming/';
        } else if (from == 'home' || from == 'dashboard') {
            path = '/opportunity_homepage/';
        }

        return this.http.get(this.apiBase + path, {
            params: params,
            headers: headers,
        });
    }

    public saveOpportunity(oppor_slug, save = 1, upcoming = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.post(
            this.apiBase + '/opportunity_save_for_later/',
            {
                oppor_slug: oppor_slug,
                save: save,
                upcoming: upcoming,
            },
            {
                headers: headers,
            }
        );
    }

    public getSavedOpportunities(user_slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', user_slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/profile_saved_opportunities/', {
            params: params,
            headers: headers,
        });
    }

    public getProfileOpportunities(user_slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', user_slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/profile_opportunities/', {
            params: params,
            headers: headers,
        });
    }

    public getLeadCapturingContent(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        return this.http.get(this.apiBase + '/opportunity_lead/', {
            params: params,
            headers: headers,
        });
    }

    public oppRequestInvitation(opporSlug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return this.http.post(
            this.apiBase + '/opportunity_invite_request/',
            {
                oppor_slug: opporSlug,
            },
            {
                headers: headers,
            }
        );
    }

    public getNotifications(offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', this.user.slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/notifications/', {
            params: params,
            headers: headers,
        });
    }

    public getOppDetail(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(
            this.apiBase + '/opportunity_detail/' + slug + '/',
            {
                params: params,
                headers: headers,
            }
        );
    }
    public getMultiLangOppDetail(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('opportunity_slug', slug);

        return this.http.get(this.apiBase + '/multilang/', {
            params: params,
            headers: headers,
        });
    }

    public getOppWinners(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('oppor_slug', slug);

        return this.http.get(this.apiBase + '/opportunity_winners/', {
            params: params,
            headers: headers,
        });
    }

    public getOppApplyDetails(
        oppor_slug,
        isFromIndia: Boolean = true,
        ip = ''
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/opportunity_apply/',
            {
                oppor_slug: oppor_slug,
                user_id: this.user.id,
                from_in: isFromIndia.toString(),
                ip: ip.toString(),
            },
            {
                headers: headers,
            }
        );
    }

    public getBio(artist_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('artist_slug', artist_slug);

        return this.http.get(this.apiBase + '/get_bio/', {
            params: params,
            headers: headers,
        });
    }

    public updateProfileViews(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/profile_views_logger/',
            {
                user_slug: slug,
                action: 'view',
                visitor_id: this.user.id,
            },
            {
                headers: headers,
            }
        );
    }

    public updateBio(bio): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/add_bio/',
            {
                bio: bio,
                user_id: this.user.id,
            },
            {
                headers: headers,
            }
        );
    }

    public getRemainingSongsForOpportunity(oppor_slug, offset = 0, limit = 3): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/profile_songs_for_opportunity/",
            {
                user_id: this.user.id,
                oppor_slug: oppor_slug,
                limit: limit,
                offset: offset,
            },
            {
                headers: headers,
            }
        );
    }

    public getRemainingVideosForOpportunity(oppor_slug, offset = 0, limit = 3): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + "/profile_videos_for_opportunity/",
            {
                user_id: this.user.id,
                oppor_slug: oppor_slug,
                offset: offset,
                limit: limit,
            },
            {
                headers: headers,
            }
        );
    }

    public applyFromExistingSongs(song_slugs, oppor_slug, radio_agreement): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        radio_agreement = radio_agreement ? 1 : 0;
        return this.http.post(
            this.apiBase + '/opportunity_apply_songs/',
            {
                song_slugs: song_slugs,
                user_id: this.user.id,
                radio_agreement: radio_agreement,
                oppor_slug: oppor_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public uploadPrivateSongs(song_slugs, oppor_slug) {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/pre_req_songs_for_opportunity/',
            {
                song_slugs: song_slugs,
                user_id: this.user.id,
                oppor_slug: oppor_slug,
            },
            {
                headers: headers,
            }
        );
    }
    public uploadPrivateVideos(video_slugs, oppor_slug) {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/pre_req_videos_for_opportunity/',
            {
                video_slugs: video_slugs,
                user_id: this.user.id,
                oppor_slug: oppor_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public applyFromExistingVideos(video_slugs, oppor_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/opportunity_apply_videos/',
            {
                video_slugs: video_slugs,
                user_id: this.user.id,
                oppor_slug: oppor_slug,
            },
            {
                headers: headers,
            }
        );
    }

    public sendOTP(mob, code = '', whatsapp = false): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + '/registration/send_otp/',
            {
                mobile_number: mob,
                code: code,
                user_id: this.user.id,
                whatsapp: whatsapp ? 1 : 0
            },
            {
                headers: headers,
            }
        );
    }

    public verifyOTP(otp, type = "mobile", newd = ''): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(
            this.apiBase + '/registration/verify_otp/',
            {
                otp: otp,
                type: type,
                nemail: newd
            },
            {
                headers: headers,
            }
        );
    }

    public followArtist(slug, task = 'follow'): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + "/songdewuser/followv2/",
            {
                artist_slug: slug,
                task: task,
            },
            {
                headers: headers,
            }
        );
    }

    public getIpAddress(): any {
        // return this.http.get('https://api.ipify.org/?format=json');
        return this.http.get(
            'https://songdew.com/shopping-cart/geoip.php?onlyIP=1'
        );
    }

    public getGeoLocation(ip): any {
        let params = new HttpParams();
        params = params.append('ip', ip.toString());

        // return this.http.get('https://songdew.com/geoIP',
        return this.http.get('https://songdew.com/shopping-cart/geoip.php', {
            params: params,
        });
    }

    public likeSong(slug, task = 'like', clap_value, activityId = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return 1;
        /* return this.http.post(
             this.apiBase + '/activity_logger/',
             {
                 song_slug: slug,
                 action: task,
                 clap_value: clap_value,
                 duration: 0,
                 ipaddress: '0000',
                 id: 0,
             },
             {
                 headers: headers,
             }
         );*/
    }
    public likeAlbum(slug, task = 'like', clap_value, activityId = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return 1
        /* return this.http.post(
             this.apiBase + '/activity_logger/',
             {
                 album_slug: slug,
                 action: task,
                 clap_value: clap_value,
                 duration: 0,
                 ipaddress: '0000',
                 id: 0,
             },
             {
                 headers: headers,
             }
         );*/
    }
    public likePlaylist(slug, task = 'like', clap_value, activityId = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return 1;
        /*return this.http.post(
            this.apiBase + '/activity_logger/',
            {
                playlist_slug: slug,
                action: task,
                clap_value: clap_value,
                duration: 0,
                ipaddress: '0000',
                id: 0,
            },
            {
                headers: headers,
            }
        );*/
    }

    public likeVideo(slug, task = 'like', clap_value, activityId = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        return 1;
        /* return this.http.post(
             this.apiBase + '/activity_logger/',
             {
                 video_slug: slug,
                 action: task,
                 clap_value: clap_value,
                 duration: 0,
                 ipaddress: '0000',
                 id: 0,
             },
             {
                 headers: headers,
             }
         );*/
    }

    public playSong(slug, type = 'song', duration = 0, activityId = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params: any;
        if (type == 'song') {
            params = {
                song_slug: slug,
                action: 'play',
                duration: duration,
                ipaddress: '0000',
                id: activityId,
            };
        } else if (type == 'album') {
            params = {
                album_slug: slug,
                action: 'play',
                duration: duration,
                ipaddress: '0000',
                id: activityId,
            };
        } else if (type == 'playlist') {
            params = {
                playlist_slug: slug,
                action: 'play',
                duration: duration,
                ipaddress: '0000',
                id: activityId,
            };
        } else if (type == 'video') {
            params = {
                video_slug: slug,
                action: 'play',
                duration: duration,
                ipaddress: '0000',
                id: activityId,
            };
        }

        return this.http.post(this.apiBase + '/activity_logger/', params, {
            headers: headers,
        });
    }

    public getArtists(type, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('type', type);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/songdewuser/', {
            params: params,
            headers: headers,
        });
    }

    public getArtist(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('user_id', this.user.id);

        return this.http.get(this.apiBase + '/songdewuser/profile/', {
            params: params,
            headers: headers,
        });
    }

    public getScreenGuide(module): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();

        return this.http.get(this.apiBase + '/screen_guide/' + module + '/', {
            params: params,
            headers: headers,
        });
    }
    public updateScreenGuide(module): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        this.http
            .post(
                this.apiBase + '/screen_guide/' + module + '/',
                {},
                {
                    headers: headers,
                }
            )
            .subscribe((res) => {
                // console.log(res);
            });
    }

    public getAchievementCards(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();

        return this.http.get(
            this.apiBase + '/songdewuser/achievements_cards/',
            { params: params, headers: headers }
        );
    }

    public getAchievements(slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('user_id', this.user.id);

        return this.http.get(this.apiBase + '/songdewuser/achievements/', {
            params: params,
            headers: headers,
        });
    }

    public getTopTasks(token): any {
        const headers = new HttpHeaders().set('Authorization', token);

        let params = new HttpParams();
        params = params.append('token', token);

        return this.http.get(this.apiBase + '/dashboard/top-tasks/', {
            params: params,
            headers: headers,
        });
    }

    public addAchievement(slug, desc, id = 0): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        if (id == 0) {
            return this.http.post(
                this.apiBase + '/songdewuser/achievements/',
                {
                    user_slug: slug,
                    user_id: this.user.id,
                    achievement_name: 'not blank',
                    achievement_description: desc,
                    achievement_id: id,
                },
                {
                    headers: headers,
                }
            );
        } else {
            return this.http.put(
                this.apiBase + '/songdewuser/achievements/',
                {
                    user_slug: slug,
                    user_id: this.user.id,
                    achievement_name: 'not blank',
                    achievement_description: desc,
                    achievement_id: id,
                },
                {
                    headers: headers,
                }
            );
        }
    }

    public getArtistCards(slug = this.user.slug, offset = 0, limit = 5): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/songdewuser/achievements/', {
            params: params,
            headers: headers,
        });
    }

    public getReviewCards(slug = this.user.slug, offset = 0, limit = 5): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/songdewuser/achievements/', {
            params: params,
            headers: headers,
        });
    }

    public topPerformingSong(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(
            this.apiBase + '/songdewsongs/top_performing_song/',
            { headers: headers }
        );
    }

    public topPerformingVideo(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.get(
            this.apiBase + '/songdewvideos/top_performing_video/',
            { headers: headers }
        );
    }

    public getProfileSongs(slug, offset = 0, limit = 20, view = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('view', view);

        return this.http.get(this.apiBase + '/songdewuser/songs/', {
            params: params,
            headers: headers,
        });
    }

    public getAllTracks(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + "/distribute/get_music_list/", {
            headers: headers,
        });
    }

    public getMyAudioSongs(slug, offset = 0, limit = 20, view = "dashboard"): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("user_slug", slug);
        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());
        params = params.append("view", view);

        return this.http.get(this.apiBase + "/distribute/genrelupload/", {
            params: params,
            headers: headers,
        });
    }

    public getProfileSongsList(slug, offset = 0, limit = 20, view = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('view', view);

        return this.http.get(this.apiBase + '/songdewuser/songslist/', {
            params: params,
            headers: headers,
        });
    }

    public getProfileAlbums(slug, offset = 0, limit = 20, view = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('view', view);

        return this.http.get(this.apiBase + '/albums/', {
            params: params,
            headers: headers,
        });
    }

    public getAlbumsForPromotion(user_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', user_slug);

        return this.http.get(this.apiBase + '/albums_for_promotion/', {
            params: params,
            headers: headers,
        });
    }
    public getTracksForPromotion(user_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', user_slug);

        return this.http.get(this.apiBase + '/tracks_for_promotion/', {
            params: params,
            headers: headers,
        });
    }
    public getUploadsForPromotion(user_slug): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', user_slug);

        return this.http.get(this.apiBase + '/dashboard/alluploadwidget/', {
            params: params,
            headers: headers,
        });
    }

    public getProfileVideos(slug, offset = 0, limit = 20, view = ''): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('view', view);

        return this.http.get(this.apiBase + '/v2/songdewuser/videos/', {
            params: params,
            headers: headers,
        });
    }

    public getProfilePlaylists(
        slug,
        offset = 0,
        limit = 20,
        is_library = false
    ): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('is_library', is_library.toString());

        return this.http.get(this.apiBase + '/playlist/user_playlists/', {
            params: params,
            headers: headers,
        });
    }

    public getProfileFollowers(slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('filter', 'followers');

        return this.http.get(this.apiBase + '/songdewuser/get_follow/', {
            params: params,
            headers: headers,
        });
    }

    public getMusicVideo(slug_album, slug_usersong): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        if (slug_album) {
            params = params.append("slug_album", slug_album);
        }
        if (slug_usersong) {
            params = params.append("slug_usersong", slug_usersong);
        }
        return this.http.get(this.apiBase + "/album/musicvideo", {
            params: params,
            headers: headers,
        });
    }

    public getLikedSongs(slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/songdewuser/liked_songs/', {
            params: params,
            headers: headers,
        });
    }

    public getLikedAlbums(slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/songdewuser/liked_albums/', {
            params: params,
            headers: headers,
        });
    }

    public getLikedVideos(slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/v2/songdewuser/liked_videos/', {
            params: params,
            headers: headers,
        });
    }

    public getLikedPlaylists(slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());

        return this.http.get(this.apiBase + '/songdewuser/liked_playlists/', {
            params: params,
            headers: headers,
        });
    }

    public getFollowedArtists(slug, offset = 0, limit = 20): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('user_slug', slug);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        params = params.append('filter', 'following');

        return this.http.get(this.apiBase + '/songdewuser/get_follow/', {
            params: params,
            headers: headers,
        });
    }

    public myOrders(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/my-orders/',
            {
                user_id: this.user.id,
                slug: this.user.slug,
            },
            {
                headers: headers,
            }
        );
    }

    public getImageUrlStatus(url: string) {
        return this.http.get(url);
    }

    public getSchemaData(url): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('url', url);

        return this.http.get(
            this.angularBase + '/shopping-cart/get-schema.php',
            {
                params: params,
            }
        );
    }

    getLeadGenerationMsg(opportunity_types_choice): any {
        let params = new HttpParams();
        params = params.append(
            'opportunity_category',
            opportunity_types_choice
        );

        return this.http.get(
            this.apiBase + '/opportunity_lead_message_widget/',
            {
                params: params,
            }
        );
    }

    ulog(page_type, page_id, complete_url = window.location.href): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        return this.http.post(
            this.apiBase + '/ulog/',
            {
                page_type: page_type,
                page_id: page_id,
                complete_url: complete_url
            },
            {
                headers: headers,
            }
        );
    }

    getRevenueReports(artist_slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("artist_slug", artist_slug);

        return this.http.get(this.apiBase + "/artist_payment/", {
            params: params,
            headers: headers,
        });
    }

    saveBankDetails(bankDetails): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(this.apiBase + "/artist_bank_details/", bankDetails, {
            headers: headers,
        });
    }
    showBankDetail(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("artist_slug", this.user.slug);


        return this.http.get(this.apiBase + "/artist_payment_info/", {
            headers: headers,
            params: params
        });
    }




    getRahatsTribute() {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();
        params = params.append('type', 'dr-rahat-indori');

        return this.http.get(
            this.apiBase + '/songs-listing/dr-rahat-indori/',
            {
                params: params,
                headers: headers
            }
        );
    }

    getArtistPreferences(): any {
        const headers = new HttpHeaders().set('Authorization', this.user.token);
        let params = new HttpParams();

        return this.http.get(
            this.apiBase + '/show_artist_preference/',
            {
                params: params,
                headers: headers
            }
        );
    }

    saveArtistPreferences(artistLevel, artistPreferences) {
        const headers = new HttpHeaders().set('Authorization', this.user.token);

        let oppTypes = [];
        artistPreferences.forEach(preference => {
            if (preference.value) {
                oppTypes.push(preference.label);
            }
        });

        return this.http.post(
            this.apiBase + '/save_artist_preference/',
            {
                artist_type: artistLevel,
                oppor_type: oppTypes
            },
            {
                headers: headers
            }
        );
    }

    videosConsideration() {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.get(this.apiBase + "/videos_confirmation/", {
            headers: headers,
        });
    }

    videoAccepted() {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.get(this.apiBase + "/videos_accepted/", {
            headers: headers,
        });
    }

    addLead(lead) {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        console.log(typeof this.user.token, "lead f");
        return this.http.post(this.apiBase + "/opp_lead/add_lead", lead, {
            headers: headers,
        });
    }

    // Non API Methods

    static getTime(x: Date) {
        let date = new Date(x);
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        let stringMinutes = minutes < 10 ? "0" + minutes : minutes;
        let strTime = hours + ":" + stringMinutes + " " + ampm;
        return strTime;
    }

    //write same method for songs with user_slug param as profileArtistQUote
    getToolDetails(song_slug, user_slug, isSong: boolean) {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = params.append("user", user_slug);
        params = params.append(isSong ? 'song_slug' : 'album_slug', song_slug);
        return this.http.get(this.apiBase + "/v2/media_tool_list/", {
            params: params,
            headers: headers,
        });
    }
    public getDistributedList(slug, offset = 0, limit = 20, view = "", onlyReleased = ""): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();

        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());
        if (onlyReleased == 'released') {
            params = params.append("onlyReleased", "1");
        } else {
            params = params.append("onlyReleased", "0");
        }




        return this.http.get(this.apiBase + "/distribute/get_distribution/", {
            params: params,
            headers: headers,
        });
    }

    public getPromoteMusic(slug, offset = 0, limit = 20, view = "", onlyReleased = ""): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();

        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());
        params = params.append("onlyReleased", "1");





        return this.http.get(this.apiBase + "/distribute/get_music_promote/", {
            params: params,
            headers: headers,
        });
    }

    public getLastUpload(slug, offset = 0, limit = 20, view = ""): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();

        params = params.append("offset", offset.toString());
        params = params.append("limit", limit.toString());


        return this.http.get(this.apiBase + "/distribute/get_distribution_complete/", {
            params: params,
            headers: headers,
        });
    }

    // new modification by kailash
    public requestGet(apiUrl, requestData, paramsList) {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        let params = new HttpParams();
        params = paramsList;
        return this.http.get(this.apiBase + "/media_tool_list/", {
            params: params,
            headers: headers,
        });
    }
    public requestPost(apiPrefix, apiName, requestData): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        const apiUrl = apiPrefix + apiName;
        return this.http.post(apiUrl, requestData, { headers: headers, });
    }

    // Growth Tools / YouTube Ads API calls have moved to
    // GrowthToolsDataService — that module now owns its own HTTP calls
    // instead of adding methods here, same as DistributionApiService does
    // for Distribution.


    public tvAgreementForm(
        videoName,
        copyRightHolder,
        Composer,
        Lyricist,
        // signee,
        emailId,
        phoneNumber,
        firstStreet,
        secondStreet,
        countryCode,
        countryId,
        // state,
        // city,
        postCode,
        videoSlug,
        agreementId
    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        if (agreementId) {

            return this.http.put(this.apiBase + '/video-agreement/',
                {
                    slug_video: videoSlug,
                    countryCode: countryCode,
                    country: countryId,
                    title: videoName,
                    // authorized_signatory: signee,
                    user: copyRightHolder,
                    Lyricist: Lyricist,
                    Composer: Composer,
                    email: emailId,
                    address: firstStreet + ' ' + secondStreet,
                    artist_id: this.user.id,
                    phone: phoneNumber,
                    // state: state,
                    // city: city,
                    post_code: postCode,
                },
                {
                    headers: headers,

                })
        } else {
            return this.http.post(this.apiBase + '/video-agreement/',
                {
                    slug_video: videoSlug,
                    countryCode: countryCode,
                    country: countryId,
                    title: videoName,
                    // authorized_signatory: signee,
                    user: copyRightHolder,
                    Lyricist: Lyricist,
                    Composer: Composer,
                    email: emailId,
                    address: firstStreet + ', ' + secondStreet,
                    artist_id: this.user.id,
                    phone: phoneNumber,
                    // state: state,
                    // city: city,
                    post_code: postCode,
                },
                {
                    headers: headers,

                })
        }

    }

    public otpSend(
        countryCode,
        mobile_number,
        user_id,
        agreement_id,
        whatsapp

    ): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.post(this.apiBase + '/agreement/send_otp/',
            {
                mobile_number: mobile_number,
                country_code: countryCode,
                user_id: user_id,
                agreement_id: agreement_id,
                whatsapp: whatsapp ? 1 : 0
            },
            {
                headers: headers,

            })


    }


    public otpVerify(
        agreement_id,
        sign,
        place,
        ip,
        otp,
        type = 'mobile'
    ): any {

        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.post(this.apiBase + '/videoagreement/verify_otp/',
            {
                agreement_id: agreement_id,
                sign: sign,
                place: place,
                ip: ip,
                otp: otp,
                single: 1,
                type: type
            },
            {
                headers: headers,

            })
    }


    public tvMetaDataForm(
        artistType,
        profileDes,
        drive_link,
        bandMembers,
        achievements,
        popularTrackList,
        ticketId,
        countryId,
        stateId,
        city

    ): any {

        // let populaTrackArray = [...popularTrack, ...popularTrackList]

        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.post(this.apiBase + "/meta-data-save/",
            {
                artist_type: artistType,
                ticket_id: ticketId,
                profile_english: profileDes,
                spotlight_english: achievements[0].achievement_description,
                achie_title: achievements[0].achievement_name,
                bm_1: bandMembers.bm_1,
                bm_1_role: bandMembers.bm_1_role,
                bm_2: bandMembers.bm_2,
                bm_2_role: bandMembers.bm_2_role,
                bm_3: bandMembers.bm_3,
                bm_3_role: bandMembers.bm_3_role,
                bm_4: bandMembers.bm_4,
                bm_4_role: bandMembers.bm_4_role,
                bm_5: bandMembers.bm_5,
                bm_5_role: bandMembers.bm_5_role,
                track_1: popularTrackList.track_1,
                track_2: popularTrackList.track_2,
                track_3: popularTrackList.track_3,
                track_4: popularTrackList.track_4,
                track_5: popularTrackList.track_5,
                drive_link: drive_link,
                country: countryId,
                state: stateId,
                city: city
            },
            {
                headers: headers,

            })



    }

    public playlistDescriptionSave(media_id, albumId, track_description, artist_description, about_track, information, media_vibe, similar_sound, similar_artist, accomplishment, playlist_fit, spotify_listeners, insta_followers, yt_followers, spotify_url, jiosaavn_url, gaana_url): any {

        const headers = new HttpHeaders().set("Authorization", this.user.token);

        return this.http.post(this.apiBase + "/playlist-description-save/",
            {
                media_id: media_id,
                album_id: albumId,
                track_description: track_description,
                artist_description: artist_description,
                about_track: about_track,
                information: information,
                media_vibe: media_vibe,
                similar_sound: similar_sound,
                similar_artist: similar_artist,
                accomplishment: accomplishment,
                playlist_fit: playlist_fit,
                spotify_listeners: spotify_listeners,
                insta_followers: insta_followers,
                yt_followers: yt_followers,
                spotify_url: spotify_url,
                jiosaavn_url: jiosaavn_url,
                gaana_url: gaana_url

            },
            {
                headers: headers,
            }
        )

    }

    public getUserProfileDetails(slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        let params = new HttpParams();
        params = params.append("id", slug);
        return this.http.get(this.apiBase + "/profile/v2/user_details/?user_slug=" + this.user.slug,  // need to open fo live
            // return this.http.get(this.apiBase + "/songdewuser/profile/?user_slug=" + this.user.slug,  // Need to remove for live
            {
                headers: headers,

            })
    }

    public getVideoList(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        // let params = new HttpParams();
        // params = params.append("id", slug);
        return this.http.get(this.apiBase + "/ticket-details/",
            {
                headers: headers,

            })
    }


    public getVideoAgreementDetail(slug): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);

        let params = new HttpParams();
        params = params.append("video_slug", slug);
        return this.http.get(this.apiBase + "/video-agreement/",
            {
                params: params,
                headers: headers
            })
    }
    public getAnimationDetail(data): Observable<Blob> {

        return this.http.post('https://sdv2.songdew.com/download', data, { responseType: 'blob' })


    }
    public cancelVideoDownload(slug): any {

        // const headers = new HttpHeaders().set("Authorization", this.user.token);

        let params = new HttpParams();
        params = params.append("song_slug", slug);


        return this.http.get('https://sdv2.songdew.com/cancel', {
            params: params
        })

    }

    public getProDetails(): any {

        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + '/pro_detail', {
            headers: headers

        })

    }


    public getSubscriptionDetails(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + '/dashboard/subscription_widget', {
            headers: headers

        })
    }

    public getPromotionalTool(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + '/promotool_list/', {
            headers: headers

        })

    }
    public getVideoPlayDetailsForTv(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + '/songdewtv/scheduler', {
            headers: headers

        })

    }

    public get<T>(path: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
        return this.http.get<T>(this.apiBase + path, { params, headers }).pipe(
            catchError(this.handleError)
        );
    }

    public whatsappPost(num) {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.post(this.apiBase + '/wa/send_verify_text', {
            mobile_number: num,

        },
            { headers: headers })
    }



    private handleError(error: HttpErrorResponse) {
        // You can customize error handling based on your application's needs
        let errorMessage = 'An error occurred.';
        if (error.error instanceof ErrorEvent) {
            // Client-side error
            errorMessage = error.error.message;
        } else {
            // Server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.error(errorMessage);
        return throwError(() => error)
    }

    public getTopUserSongs(): any {
        const headers = new HttpHeaders().set("Authorization", this.user.token);
        return this.http.get(this.apiBase + '/dashboard/top-user-songs/', {
            headers: headers
        });
    }




}
